const BASE = "/api";

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { "Content-Type": "application/json" },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: res.statusText }));
    throw new Error(err.detail || "Request failed");
  }
  return res.json();
}

export const api = {
  getBills:     ()         => request("/bills/"),
  getBill:      (id)       => request(`/bills/${id}`),
  updateSplits: (id, data) => request(`/bills/${id}/splits`,   { method: "PATCH",  body: JSON.stringify(data) }),
  finalizeBill: (id)       => request(`/bills/${id}/finalize`, { method: "POST" }),
  deleteBill:   (id)       => request(`/bills/${id}`,          { method: "DELETE" }),
  getSettings:  ()         => request("/settings/"),
  manualPoll:   ()         => request("/poll",                 { method: "POST" }),
};
